// Status & phase helpers
export const PHASES = ["discovery", "prompting", "build", "review", "audit", "sign_off", "betrieb"];
export const PHASE_LABELS = {
  discovery: "Discovery",
  prompting: "Prompting",
  build: "Build",
  review: "Review",
  audit: "Audit",
  sign_off: "Sign-off",
  betrieb: "Betrieb",
};
export const RUN_STATUS = ["offen", "in_arbeit", "blockiert", "abgeschlossen", "abgelehnt"];
export const STATUS_LABELS = {
  offen: "Offen",
  in_arbeit: "In Arbeit",
  blockiert: "Blockiert",
  abgeschlossen: "Abgeschlossen",
  abgelehnt: "Abgelehnt",
};
export const CUSTOMER_PHASES = ["in_vorbereitung", "in_umsetzung", "in_pruefung", "freigabe", "live"];
export const CUSTOMER_PHASE_LABELS = {
  in_vorbereitung: "In Vorbereitung",
  in_umsetzung: "In Umsetzung",
  in_pruefung: "In Prüfung",
  freigabe: "Freigabe",
  live: "Live",
};
export const PHASE_TO_CUSTOMER = {
  discovery: "in_vorbereitung",
  prompting: "in_vorbereitung",
  build: "in_umsetzung",
  review: "in_pruefung",
  audit: "in_pruefung",
  sign_off: "freigabe",
  betrieb: "live",
};

export const PHASE_STYLES = {
  discovery: { bg: "#F4F4F5", text: "#3F3F46", border: "#D4D4D8" },
  prompting: { bg: "#E0E7FF", text: "#3730A3", border: "#A5B4FC" },
  build: { bg: "#FEF3C7", text: "#92400E", border: "#FDE68A" },
  review: { bg: "#FFEDD5", text: "#9A3412", border: "#FDBA74" },
  audit: { bg: "#FEE2E2", text: "#991B1B", border: "#FECACA" },
  sign_off: { bg: "#DCFCE7", text: "#166534", border: "#86EFAC" },
  betrieb: { bg: "#ECFEFF", text: "#155E75", border: "#A5F3FC" },
};

export const STATUS_STYLES = {
  offen: { bg: "#F4F4F5", text: "#525252", border: "#D4D4D8" },
  in_arbeit: { bg: "#DBEAFE", text: "#1E40AF", border: "#93C5FD" },
  blockiert: { bg: "#FEE2E2", text: "#991B1B", border: "#FCA5A5" },
  abgeschlossen: { bg: "#DCFCE7", text: "#166534", border: "#86EFAC" },
  abgelehnt: { bg: "#FEF2F2", text: "#7F1D1D", border: "#FECACA" },
};

export const SEVERITY_LABELS = {
  info: "Info",
  low: "Niedrig",
  medium: "Mittel",
  high: "Hoch",
  critical: "Kritisch",
};

export const SEVERITY_STYLES = {
  info: { bg: "#F1F5F9", text: "#334155", border: "#CBD5E1" },
  low: { bg: "#ECFCCB", text: "#3F6212", border: "#BEF264" },
  medium: { bg: "#FEF3C7", text: "#854D0E", border: "#FDE68A" },
  high: { bg: "#FFEDD5", text: "#9A3412", border: "#FDBA74" },
  critical: { bg: "#FEE2E2", text: "#7F1D1D", border: "#FCA5A5" },
};

export const ROLE_LABELS = {
  admin: "Admin",
  intern_delivery: "Delivery",
  intern_architekt: "Architektur",
  intern_audit: "Audit",
  kunde_entscheider: "Entscheider",
  kunde_mitwirkend: "Mitwirkend",
  externer_reviewer: "Externer Reviewer",
};

export const fmtDate = (iso) => {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    return d.toLocaleString("de-DE", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });
  } catch { return iso; }
};
